
class MarqueeComponent extends HTMLElement {
  constructor() {
    super();
    this.init();
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init();
      }
    });
  }

  init() {
    const track = this.querySelector('.marquee-track');
    if (!track) return;

    track.querySelectorAll('[aria-hidden="true"]').forEach((el) => el.remove());

    const trackWidth = track.scrollWidth;
    const originalLength = track.children.length;

    track.insertAdjacentHTML('beforeend', track.innerHTML);
    track.insertAdjacentHTML('beforeend', track.innerHTML);

    Array.from(track.children).forEach((item, index) => {
      if (index >= originalLength) {
        item.setAttribute('aria-hidden', 'true');
      }
    });

    const id = this.dataset.marqueeId;
    const duration = this.dataset.marqueeDuration;
    const direction = this.dataset.marqueeDirection;

    const keyframes = direction === 'right'
      ? `@keyframes marquee_${id} { from { transform: translateX(-${trackWidth}px); } to { transform: translateX(0); } }`
      : `@keyframes marquee_${id} { to { transform: translateX(-${trackWidth}px); } }`;

    const style = document.createElement('style');
    style.textContent = `
      #marquee-${id} .marquee-track {
        animation-name: marquee_${id};
        animation-duration: ${duration}s;
      }
      ${keyframes}
    `;
    this.before(style);

    this.classList.add('marquee-initialized');
  }
}

customElements.define('marquee-component', MarqueeComponent);
